import { useCallback, useEffect, useRef } from 'react';
import * as Obj from '@pkg/utils/objects';
import mutate from './mutate';
import * as Reducers from './reducers';

/**
 * @param {Object} input
 * @param {Object} input.state
 * @param {Function} input.setState - publishes the snapshot and returns its graph
 * @param {Function} input.onMutate
 * @returns {Function}
 */
export default function useGraphDispatcher({ state, setState, onMutate }) {
  const ref = useRef();
  useEffect(() => {
    ref.current = { state, onMutate };
  }, [state, onMutate]);

  /**
   * Dispatch reducers to mutate the graph
   *
   * @param {String} action
   * @param {Object} input
   * @returns {Promise}
   */
  const handler = async (action, input) => {
    const { state, onMutate } = ref.current;

    const mutation = Obj.get(Reducers, action)(state, input);
    if (!mutation) return;

    const mutated = mutate(state, mutation);
    delete mutation.entities?.people;

    // Consecutive dispatches must see this graph before React rerenders.
    ref.current.state = setState(mutated);
    onMutate(mutation, action);
  };

  return useCallback(handler, []);
}
